import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewRef,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

import { MatDialog } from '@angular/material/dialog';

import { ThumbsOptions } from 'swiper/types';
import { SwiperOptions } from 'swiper/types/swiper-options';

import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';

import { SwiperDirective } from '../../directives/swiper.directive';
import { SsrHelperService } from 'src/app/core/services/ssr-helper.service';
import { CloudinaryService } from 'src/app/core/services/cloudinary.service';

import { AttractionInfoComponent } from '../../used-components/attraction-info/attraction-info.component';

import { Swiper } from 'swiper';

@Component({
    selector: 'app-gallery',
    templateUrl: 'gallery.component.html',
    styleUrls: ['gallery.component.scss'],
    imports: [SwiperDirective, NgOptimizedImage, SafeHtmlPipe]
})
export class GalleryComponent
  implements AfterViewInit, OnChanges, OnInit, OnDestroy
{
  @Input() items: any[];
  @Input() isFirst: boolean = false;
  @Input() isTripPlannerPage: boolean = false;
  @Input() isCityPage: boolean = false;
  @Input() disablePagination: boolean = false;
  @Output() selectedItem: EventEmitter<any> = new EventEmitter<any>();
  public currentSelectedItem: any;
  public thumbnailsSwiperOptions: SwiperOptions = {
    spaceBetween: 5,
    slidesPerView: 'auto',
    slideToClickedSlide: true,
    watchSlidesProgress: true,
    userAgent: this.ssrHelperService.userAgent,
  };
  public gallerySwiperOptions: SwiperOptions | null;
  @ViewChild('thumbnailsSwiper') thumbnailsSwiperRef: SwiperDirective;
  private gallerySwiper: Swiper;
  private thumbnailsSwiper: Swiper;
  private realIndexCalcNumber: number = 0;

  constructor(
    public cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private cloudinaryService: CloudinaryService,
    private readonly ssrHelperService: SsrHelperService,
  ) {}

  get isCityTripPlanner(): boolean {
    return this.isTripPlannerPage && this.isCityPage;
  }

  ngOnInit() {
    this.changeImageUrl();
    this.setSwiperOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes?.items.firstChange) {
      this.realIndexCalcNumber = this.items.length;
      this.detectViewChanges();
      this.changeImageUrl();
    }

    if (changes?.items) {
      this.currentSelectedItem = this.items[0];
    }
  }

  ngOnDestroy() {
    if (this.thumbnailsSwiper) {
      this.thumbnailsSwiper.destroy(true, true);
    }

    if (this.gallerySwiper) {
      this.gallerySwiper.destroy(true, true);
    }
  }

  ngAfterViewInit() {
    this.detectViewChanges();
  }

  public onSwiperClick() {
    if (this.isCityPage) {
      this.dialog.open(AttractionInfoComponent, {
        width: '592px',
        maxWidth: '96vw',
        maxHeight: '96%',
        data: {
          title: this.currentSelectedItem.name,
          description: this.currentSelectedItem.shortDescription,
          imageUrl: this.currentSelectedItem.imageUrl,
        },
      });
    }
  }

  etThumbs(): ThumbsOptions | undefined {
    if (!this.thumbnailsSwiperRef?.swiperInstance) return undefined;
    const thumbs: ThumbsOptions = {
      swiper: this.thumbnailsSwiperRef?.swiperInstance,
      slideThumbActiveClass: 'swiper-slide-active',
    };
    return this.isTripPlannerPage || this.isCityPage ? undefined : thumbs;
  }

  private detectViewChanges(): void {
    if (!(this.cdr as ViewRef).destroyed) {
      this.cdr.detectChanges();
    }
  }

  private emitPlaceChanges(slideIndex: number): void {
    let realIndex = Math.abs(this.realIndexCalcNumber - slideIndex);
    if (this.realIndexCalcNumber > 0 && realIndex === this.items.length) {
      realIndex = 0;
    }

    this.currentSelectedItem = this.items[realIndex];
    this.selectedItem.emit(this.items[realIndex]);
  }

  private changeImageUrl(): void {
    this.items.forEach((item) => {
      if (item.imageUrl && !item.imageUrl?.includes('cloudinary')) {
        item.imageUrl = this.cloudinaryService.getCloudImage(item.imageUrl);
      }
    });
  }

  private setSwiperOptions(): void {
    const gallerySwiperOptions: SwiperOptions = {
      spaceBetween: 0,
      slidesPerView: 'auto',
      slideToClickedSlide: false,
      userAgent: this.ssrHelperService.userAgent,
      thumbs: this.etThumbs(),
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        slideChange: (slide: Swiper) => this.emitPlaceChanges(slide.realIndex),
      },
    };

    if (!this.disablePagination) {
      gallerySwiperOptions.pagination = {
        el: '.swiper-pagination',
        type: 'bullets',
        dynamicBullets: true,
      };
    }

    this.gallerySwiperOptions = gallerySwiperOptions;
  }
}
